import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayButton = _resolveComponent("PlayButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden relative w-full", [$props.fullScreen ? 'h-full' : `h-0 ${$options.padding}`]])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      id: "player-1",
      class: "absolute top-0 left-0 w-full h-full border-none"
    }, null, -1)),
    ($data.firstPlay)
      ? (_openBlock(), _createBlock(_component_PlayButton, {
          key: 0,
          "tablet-size": $options.tabletPlayButtonSize,
          "desktop-size": $options.desktopPlayButtonSize,
          "aria-label": $options.$globalLabels.play,
          onClick: $options.playVideo
        }, null, 8, ["tablet-size", "desktop-size", "aria-label", "onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      class: _normalizeClass(["object-cover object-center absolute top-0 left-0 w-full h-full z-5", { hidden: !$data.firstPlay }]),
      src: $options.placeHolderImageSrc,
      alt: ""
    }, null, 10, _hoisted_1),
    ($data.firstPlay && $props.fullScreen)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true)
  ], 2))
}